<template>
  <div class="dashboard-action-button__wrapper">
    <button
      @click="clicked"
      @keydown.esc="hideExpandableContent"
      class="dashboard-action-button__btn"
      :class="{
        'dashboard-action-button__btn--active': active,
        'dashboard-action-button__btn-expandable': expandable,
        'dashboard-action-button__btn-expandable--expanded': isExpanded,
      }">
      <slot></slot>
    </button>
    <template v-if="isExpanded">
      <!--
        eslint-disable vuejs-accessibility/click-events-have-key-events
        Rule does not apply to this case! Element has no focus, it does not trigger key events.
      -->
      <div
        class="dashboard-action-button__expandable-content-backdrop"
        @click="hideExpandableContent"></div>
      <!-- eslint-enable vuejs-accessibility/click-events-have-key-events -->
      <div class="dashboard-action-button__expandable-content-wrapper">
        <slot
          name="expandable-content"
          v-bind="{ hideExpandableContent }">
          <!-- Binds props/methods to be exposed to client components when using this slot -->
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'dashboard-action-button',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isExpanded: false,
  }),
  methods: {
    clicked() {
      if (this.expandable) {
        this.isExpanded = !this.isExpanded;
      }

      this.$emit('click');
    },
    hideExpandableContent() {
      this.isExpanded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-action-button__wrapper {
  display: inline-flex;
  .dashboard-action-button__btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: .875rem;
    padding: .325rem 1rem;
    border: 1px solid;
    color: #A4A4A4;
    border-radius: 8px;
    background-color: transparent;
    &.dashboard-action-button__btn-expandable {
      &::after {
        content: '';
        width: 7px;
        height: 7px;
        border: 2px solid;
        border-top-color: transparent;
        border-left-color: transparent;
        transform: rotate(45deg);
        margin-left: .325rem;
        margin-top: -3px;
      }
      &.dashboard-action-button__btn-expandable--expanded {
        color: #1BB9A4;
        &::after {
          margin-top: 3px;
          transform: rotate(-135deg);
        }
      }
    }
    &.dashboard-action-button__btn--active {
      color: #1BB9A4;
      background-color: rgba(27, 185, 164, .05);
      font-weight: 600;
      border-width: 2px;
    }
  }
  .dashboard-action-button__expandable-content-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1021;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .3);
  }
  .dashboard-action-button__expandable-content-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 92vw;
    max-height: 92vh;
    transform: translate(-50%, -50%);
    z-index: 1022;
  }
}

@include media-breakpoint-up(lg) {
  .dashboard-action-button__wrapper {
    position: relative;
    overflow: visible;
    .dashboard-action-button__btn {
      font-size: 1rem;
      &.dashboard-action-button__btn-expandable {
        &::after {
          margin-left: .75rem;
        }
      }
    }

    .dashboard-action-button__expandable-content-backdrop {
      z-index: 1018;
      background-color: transparent;
    }

    .dashboard-action-button__expandable-content-wrapper {
      z-index: 1019;
      position: absolute;
      top: calc(100% + .625rem);
      left: 0;
      transform: none;
      width: auto;
      height: auto;
    }
  }
}
</style>
